import GeneralBookingForm from "./_GeneralBookingForm";
import { buildHisSpecialtyOptions, buildPackageOptions } from "./utils";

const SCROLL_OFFSET = 164;

export default class PackageBooking extends GeneralBookingForm {
  constructor({ dateTimeManager } = {}) {
    super({
      formSelector: "#the-package-booking-form",
      formType: "package",
      dateTimeManager,
      managers: { slot: dateTimeManager, crm: null },
    });

    if (!this.isActive) {
      return;
    }

    this.bindModalRelationLoadingListeners();
    this.bindScrollToForm();
  }

  setCustomSelectValue($list, value, fallbackText = "") {
    const normalized = value === undefined || value === null ? "" : String(value);
    const $select = $list.closest(".custom-select");
    const $current = $select.find(".current-value");
    const $input = $select.find('input[type="hidden"]').first();
    const $option = $list.find(`.option[data-value="${normalized}"]`).first();

    $list.find(".option").removeClass("active");
    if ($option.length) {
      if (normalized === "" && fallbackText) {
        $input.val("");
        $current.html(fallbackText).addClass("default-value");
        return true;
      }

      $option.addClass("active");
      $input.val(normalized);
      $current.html($option.html()).removeClass("default-value");
      return true;
    }

    $input.val("");
    $current.html(fallbackText).addClass("default-value");
    return false;
  }

  populateRelationSelects(hospital) {
    const $specialtiesSelect = this.$form.find("#specialties-select-list");
    const $packagesSelect = this.$form.find("#packages-select-list");
    const packageId =
      packageBookingFormVars?.book_package ||
      this.$form.find('input[name="booking-package"]').val();

    const packageData = buildPackageOptions(hospital.packages);

    $specialtiesSelect.html(buildHisSpecialtyOptions(hospital.specialties));
    $packagesSelect.html(packageData.html);

    this.setCustomSelectValue(
      $specialtiesSelect,
      packageBookingFormVars?.book_specialty || "",
      HM_Variables?.frontend_lang?.select_placeholders?.choose_specialty ||
        "Chọn chuyên khoa",
    );
    this.setCustomSelectValue(
      $packagesSelect,
      packageId,
      HM_Variables?.frontend_lang?.select_placeholders?.choose_package ||
        "Chọn gói khám",
    );
  }

  initRelationData() {
    if (
      typeof packageBookingFormVars === "undefined" ||
      !packageBookingFormVars?.hospital
    ) {
      return;
    }

    const hospitalRef = packageBookingFormVars.hospital;
    let hospital = hospitalRef;
    if (Array.isArray(HM_Variables?.hospitals)) {
      const matched = HM_Variables.hospitals.find(
        (item) =>
          String(item.id) === String(hospitalRef.id) ||
          String(item.hospital_id) === String(hospitalRef.hospital_id),
      );
      if (matched) {
        hospital = matched;
      }
    }
    const $form = this.$form;
    const $hospitalsSelect = $form.find("#hospitals-select-list");
    const $hospitalsInput = $form.find("input[name='booking-hospital']");
    const hospitalSubmissionId = hospital.hospital_id;

    $hospitalsInput.val(hospitalSubmissionId);

    const $hospitalsCustomSelect = $hospitalsSelect.closest(".custom-select");
    $hospitalsCustomSelect
      .find(".current-value")
      .html(hospital.title)
      .removeClass("default-value");

    const shortName = hospital.hospital_shortname || "";
    $hospitalsSelect.html(
      `<li class="option active" data-value="${hospitalSubmissionId}" data-hospital="${shortName}">${hospital.title}</li>`,
    );

    $hospitalsCustomSelect.css({
      "pointer-events": "none",
      opacity: "0.7",
    });

    this.handleHospitalSelection(hospital);
    this.applyUrlBookingPreselection();
    this.populateRelationSelects(hospital);

    $form
      .find('input[name="phone"]')
      .on("input.otpPhoneChange change.otpPhoneChange", () => {
        this.clearOtpVerificationToken();
      });
  }

  selectManagerForHospital() {
    const slot = this.managers && this.managers.slot;
    this.activeManager = slot || null;
    this.dateTimeManager = slot || null;
    this.bookingTimeLoadingMessage = this.bookingTimeLoadingMessageLegacy;

    if (this.usesBookingTimeRelationLoading && !slot) {
      this.setBookingTimeLoading(false);
    }
  }

  resetCustomSelects() {
    super.resetCustomSelects();
    this.initRelationData();
  }

  bindScrollToForm() {
    $(document)
      .off("click.packageBookingScroll", ".js-scroll-to-package-booking")
      .on("click.packageBookingScroll", ".js-scroll-to-package-booking", (e) => {
        e.preventDefault();
        const $target = $("#package-booking-form");
        if (!$target.length) {
          return;
        }

        const top = $target.offset().top - SCROLL_OFFSET;
        $("html, body").animate({ scrollTop: top }, 400);
      });
  }
}
